module.exports = __webpack_public_path__ + "static/img/news_banner.d27073a3.jpg";